import {RemoveSample, RemoveSampleCallback, RemoveSampleContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new RemoveSample()
const getBagCallbackESB = new RemoveSampleCallback()

export const SubscribeToShoppingBagRemoveSample = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadApiData(siteUrl, data)
    })
}

class ShoppingBagRemoveSampleModel {
    id = ""
}

const LoadApiData = (url: string, data: RemoveSampleContractModel) => {
    const apiModel = new ShoppingBagRemoveSampleModel()
    apiModel.id = data.id

    ShoppingBagApiPost(apiModel, `${url}/bag/removeSample`, getBagCallbackESB, data.eventId)
}
